import React from 'react';
import type {
    ISellingPoints, IVariant
} from 'base/interfaces/product';
import styles from './index.module.less';
import productStyles from '@app/product/index.module.less';
import { useTrans } from 'base/utils/i18n';

declare type IProps = {
    shownVariant: IVariant;
}

const PointItem = ({ item }: { item: ISellingPoints }) => {
    return (
        <ul className={styles.pointItem}>
            <li>
                <strong className={styles.pointTitle}>{item.textName ? `${item.textName}: ` : ""}</strong>
                <span className={styles.pointValue}> {item.textValue}</span>
            </li>
        </ul>
    )
};

const ProductSellingPoints: React.FC<IProps> = (props) => {
    const {
        shownVariant,
    } = props

    const points = shownVariant.productSellingPoints
    const { t } = useTrans();

    return !shownVariant.desc && !points.length ? null : (
        <div>
            <div className={productStyles['right-module']}>
                <h2 className={productStyles['module-title']}>
                    {t('web_product_selling_pints_title')}
                </h2>
            </div>
            <ul className={styles.sellingPoints}>
                {/*商品简介*/}
                <li dangerouslySetInnerHTML={{ __html: shownVariant.desc || '' }}/>
                {(points || []).map((item: ISellingPoints, index: number) => (
                    <li key={index}>
                        <strong className={styles.pointTitle}>{item.textName ? `${item.textName}: ` : ""}</strong>
                        <span className={styles.pointValue}> {item.textValue}</span>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default ProductSellingPoints;
